export default __webpack_public_path__ + "static/media/logo_light.6e87cb30.png";